module.exports = __webpack_public_path__ + "static/img/headImgf.02f2fa2b.png";